<div class="ps-form-container">
  <h2>Download disponível</h2>
  <p>Seu arquivo já está disponível! Clique no botão abaixo para realizar o download</p>
  <a mat-raised-button [href]="reportUrl" target="_blank" download="relatorio">
    Realizar download
  </a>
</div>
